import connectIcon from 'a/eReader/content/images/chain.svg';
import unmaskThatIcon from 'a/eReader/content/images/mask.svg';
import questionIcon from 'a/eReader/content/images/star.svg';
import graphicOrganizerIcon from 'a/eReader/content/images/gold-star.svg';
import wordCityIcon from 'a/eReader/content/images/books.svg';
import hangryGoblinsIcon from 'a/eReader/content/images/goblin.svg';
import cutItOutIcon from 'a/eReader/content/images/scissors.svg';
import evidenceTagIcon from 'a/eReader/content/images/marker.svg';

const UNMASK = 'unmask';
const CONNECT = 'connect';
const INLINE_TEXT = 'inlineText';
const INLINE_IMAGES = 'inlineImages';
const WORD_CITY = 'wordCity';
const HANGRY_GOBLINS = 'hangryGoblins';
const CUT_IT_OUT = 'cutItOut';
const GRAPHIC_ORGANIZER_TYPE = 'graphicOrganizer';

export const EVIDENCE_TAG = 'tagEvidence';
export const EVIDENCE_TAGGING = 'evidenceTagging';
export const GRAPHIC_ORGANIZER = 'activityType.graphicOrganizer';
export const POST_READING = 'activityType.postReading';

export const ACTIVITY_TYPES = [
  UNMASK,
  CONNECT,
  INLINE_TEXT,
  INLINE_IMAGES,
  WORD_CITY,
  HANGRY_GOBLINS,
  CUT_IT_OUT,
  EVIDENCE_TAG,
  GRAPHIC_ORGANIZER_TYPE,
];

export const ACTIVITY_TYPES_ENUM = {
  UNMASK,
  CONNECT,
  INLINE_TEXT,
  INLINE_IMAGES,
  WORD_CITY,
  HANGRY_GOBLINS,
  CUT_IT_OUT,
  EVIDENCE_TAG,
  GRAPHIC_ORGANIZER_TYPE,
};

export const MASKED_ACTIVITY_TYPES = [
  CONNECT,
  WORD_CITY,
  HANGRY_GOBLINS,
];

export const ANCHORED_ACTIVITIES = [
  INLINE_TEXT,
  EVIDENCE_TAGGING,
  INLINE_IMAGES,
];

export const MULTIPLE_CHOICE_ACTIVITIES = [ACTIVITY_TYPES_ENUM.INLINE_TEXT, ACTIVITY_TYPES_ENUM.INLINE_IMAGES];

export const ACTIVITY_BADGES = {
  connect: { icon: connectIcon, backgroundColor: '#419eff', ariaLabelKey: 'openConnectItActivity' },
  unmask: { icon: unmaskThatIcon, backgroundColor: '#ff7287', ariaLabelKey: 'openUnmaskThatActivity' },
  inlineText: { icon: questionIcon, backgroundColor: '#ab71ff', ariaLabelKey: 'openReadingQuestionActivity' },
  inlineImages: { icon: questionIcon, backgroundColor: '#ab71ff', ariaLabelKey: 'openReadingQuestionActivity' },
  graphicOrganizer: {
    icon: graphicOrganizerIcon,
    backgroundColor: '#fca73c',
    ariaLabelKey: 'openGraphicOrganizerActivity',
  },
  wordCity: { icon: wordCityIcon, backgroundColor: '#03ae00', ariaLabelKey: 'openWordCityActivity' },
  hangryGoblins: { icon: hangryGoblinsIcon, backgroundColor: '#03ae00', ariaLabelKey: 'openHangryGoblinsActivity' },
  cutItOut: { icon: cutItOutIcon, backgroundColor: '#03ae00', ariaLabelKey: 'openCutItOutActivity' },
  tagEvidence: { icon: evidenceTagIcon, backgroundColor: '#ff66d6', ariaLabelKey: 'openEvidenceTaggingActivity' },
};

export const identifiersByType = {
  [ACTIVITY_TYPES_ENUM.GRAPHIC_ORGANIZER_TYPE]: 'graphicOrganizerId',
  [ACTIVITY_TYPES_ENUM.EVIDENCE_TAG]: 'activityId',
  [POST_READING]: 'questionId',
};
